import script from "./summary_five.vue?vue&type=script&setup=true&lang=js"
export * from "./summary_five.vue?vue&type=script&setup=true&lang=js"

import "./summary_five.vue?vue&type=style&index=0&id=67a83e20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a83e20"]])

export default __exports__